"use client";

import { useState } from "react";

const DAY_ORDER = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const DAY_SHORT = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export default function HoursTable({ hours, todayName, theme }) {
  // Strip any leading ! so we can re-apply it with !important via the [&]:! escape
  const rawBg = (theme?.dayPickerBg ?? theme?.btnBg ?? "bg-gray-800").replace(/^!/, "");
  const selectedBg = `!${rawBg}`;
  // Rotate day order so today is first, matching the reference UI
  const todayIdx = DAY_ORDER.indexOf(todayName);
  const rotatedOrder = todayIdx >= 0
    ? [...DAY_ORDER.slice(todayIdx), ...DAY_ORDER.slice(0, todayIdx)]
    : DAY_ORDER;
  const ordered = rotatedOrder.map((d) => hours.find((h) => h.day === d)).filter(Boolean);
  const [selectedDay, setSelectedDay] = useState(todayName);
  const selectedHours = ordered.find((h) => h.day === selectedDay);

  return (
    <div>
      <p className="text-xs text-gray-500 uppercase tracking-wide mb-2">Today</p>
      <div className="flex gap-1.5 mb-4 flex-wrap">
        {ordered.map((h) => (
          <button
            type="button"
            key={h.day}
            onClick={() => setSelectedDay(h.day)}
            className={`!w-9 !h-9 flex items-center justify-center !rounded-full text-[10px] font-semibold transition-colors
              ${
                h.day === selectedDay
                  ? `${selectedBg} !text-white`
                  : "border border-gray-300 !text-gray-600 hover:border-gray-500 hover:bg-gray-100"
              }`}
            aria-label={h.day}
            aria-pressed={h.day === selectedDay}>
            {DAY_SHORT[h.day]}
          </button>
        ))}
      </div>

      {selectedHours && (
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="font-bold text-gray-900">{selectedHours.day}</span>
            {selectedHours.isRestaurantClosed ? (
              <span className="text-sm text-red-600">Closed</span>
            ) : (
              <span className="text-sm">
                {selectedHours.hoursInfo.find((h) => h.hourCode === "OP")?.startTime} –{" "}
                {selectedHours.hoursInfo.find((h) => h.hourCode === "OP")?.endTime}
              </span>
            )}
          </div>

          {!selectedHours.isRestaurantClosed && (
            <div className="space-y-1">
              {selectedHours.hoursInfo
                .filter((h) => h.hourCode !== "OP")
                .map((h, i) => (
                  <div key={i} className="flex justify-between text-xs text-gray-600">
                    <span>{h.name}</span>
                    <span>
                      {h.startTime} – {h.endTime}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
